<template>
    <div>
        <offer-basket v-if="showBasket" v-bind:basketProp="basket" @hideBasket="hideBasket" @triggerReceiptModal='triggerReceiptModal'/>
        <order-id-receipt v-if="showOrderIdReceipt" v-bind:orders="basketOrder" :showOrderHistoryLink='true' @hideOrderIdReceipt='hideReceiptModal()'/>

        <div class="nav-tabs_parent">
            <ul class="nav nav-tabs" id="navbar-list">
                <li class="nav-item" :class="{active:favouriteOptionSelected===key}" v-for="(service,key) in favouriteOptions" :key="key">
                    <a href="#" class="nav-link" @click="selectTab(key, service.type)">
                        {{service.type}}
                        <span class="delete-item" v-if="favouriteOptionSelected === key" @click="removeFavourite()"></span>
                    </a>
                </li>
                <li v-if="favCreated && marketFavouritesList.length < 4" class="nav-item add">
                    <a href="#" class="d-block text-platform-default w-100" @click="openModalMethod">
                        <i class="fas fa-plus"></i>
                    </a>
                </li>
            </ul>    
        </div>
        <div class="card border-radius-top-left-0">
            <div class="table-container">
                <div class="row py-3 mx-0">
                    <div class="d-flex justify-content-start col-6">
                        <label for="select-fuel-type" class="mr-2 mb-0 mt-2 text-nowrap">Filter by:</label>
                        <el-select
                            v-model="selectVmodelFuelDropDown"
                            value-key="_id"
                            filterable
                            placeholder=""
                        >
                            <el-option
                            v-for="(option, index) in dropDownOptions"
                            :key="index"
                            :label="option.name"
                            :value="option"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div 
                        class="col-7"
                        :class="{
                            'order-3 mt-2' : $breakpoint.lgAndDown
                        }"
                        v-if="serviceSelected == 'Delivered in'"
                    >
                        <span class="din-buttons d-flex align-items-start justify-content-end">
                            <button v-for="(day, dayIndex) in daysList" :key="dayIndex" class="btn day-selection"
                                :class="[ deliveredInDaysSelected.includes(day) ? 'btn-neutral' : 'btn-outline-t_grey', {'ml-2' : dayIndex !== 0 }]"
                                @click="selectDay(day)">
                                {{day | daydateformat}}
                            </button>
                        </span>
                    </div>
                    
                   <div v-if="!isGreenBsp" class="d-flex col-6 pl-0 justify-content-end">
                        <!--i class="fas fa-sliders-h" :class="{filtered: displayFilteredOffers}" @click="showFilters()"></i-->
                    </div>
                </div>
                <div :class="{'mx-3' : $breakpoint.mdAndDown}">
                    <div v-if="filterOffersList < 1 && serviceSelected !== 'Delivered in'" class="px-0 alert tables-alert-custom-message-notify mt-3 text-center">
                        <i class="fas fa-info-circle mr-2"></i>
                        Sorry, no offers for this selection
                    </div>
                    <!-- if delivered in -->
                    <table class="table responsive-table" v-else-if="serviceSelected == 'Delivered in'">
                        <thead>
                            <tr>
                                <th v-if="item.used_by.includes(serviceSelected)" v-for="(item,key) in columnTitle" :key="key">
                                    <span>{{item.title}}</span>
                                    <i v-if="activeSortColumn === item.sortingKey && activeSortDirection == 'asc'" 
                                        :class="[{'selected': activeSortColumn == item.sortingKey  && activeSortDirection == 'asc'},`fas fa-sort-${item.sort_icon}-down sort-icon` ]" 
                                        size="lg" @click="sortColumn(item.sortingKey, 'desc')">
                                    </i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn === item.sortingKey && activeSortDirection == 'desc'? ['selected',`fa-sort-${item.sort_icon}-up`] : `fa-sort-${item.sort_icon}-down` " 
                                        size="lg" @click="sortColumn(item.sortingKey, 'asc')">
                                    </i>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                v-for="(haulage, key) in haulageList" :key="key"
                            >
                                <td v-if="haulage.valid">
                                    <!-- <span v-if="key == 0 || haulageList[key - 1].location_id !== haulage.location_id">{{haulage.location.name}}</span> -->
                                    {{haulage.location.name}}
                                </td>
                                <td v-if="haulage.valid" >{{haulage.seller.name}}</td>
                                <td v-if="haulage.valid" >
                                    <span v-if="haulage.fuel_id == productConfig.KeroseneId">37,500</span>
                                    <span v-else>36,000</span>
                                </td>
                                <td v-if="haulage.valid" >{{haulage.fuel_measurement_id | fuelmeasurementtype}}</td>
                                <td v-if="haulage.valid" >{{haulage.deliveryDate | daydateformat}}</td>
                                <td v-if="haulage.valid" >{{haulage.credit.days | creditdaysformat}}</td>
                                <td v-if="haulage.valid" >{{haulage.isContract | contracttype}}</td>
                                <td v-if="haulage.valid" >
                                    {{haulage.dayDeliveryPpl | priceformat}}&nbsp;
                                    <i 
                                        v-if="haulage.type_id === 'TRACKING'"
                                        class="fas fa-sm fa-rss tracking-active-icon-color mb-2"
                                        data-toggle="tooltip" data-placement="bottom" 
                                        title="This Offer Price updates every 30 seconds"
                                    ></i>
                                </td>
                                <td class="text-right" v-if="haulage.valid" >
                                    <button class="btn btn-confirm w-120px" :disabled=getIsPlatformClosed @click="openBasket(haulage, $event)">Buy</button>
                                </td>
                                <th v-if="!haulage.valid" class="no-results" :class="{'w-50': $breakpoint.mdAndDown}">{{haulage.name}}</th>
                                <td v-if="!haulage.valid" class="no-results text-center" :class="{'w-50': $breakpoint.mdAndDown}" colspan="8"> No offers available at this time</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- if anything else but delivered in -->
                    <table class="table responsive-table" v-else>
                        <thead>
                            <tr>
                                <th v-if="item.used_by.includes(serviceSelected)" v-for="(item,key) in columnTitle" :key="key">
                                    <span>{{item.title}}</span>
                                    <i v-if="activeSortColumn === item.sortingKey && activeSortDirection == 'asc'" 
                                        :class="[{'selected': activeSortColumn == item.sortingKey  && activeSortDirection == 'asc'},`fas fa-sort-${item.sort_icon}-down sort-icon` ]" 
                                        size="lg" @click="sortColumn(item.sortingKey, 'desc')">
                                    </i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn === item.sortingKey && activeSortDirection == 'desc'? ['selected',`fa-sort-${item.sort_icon}-up`] : `fa-sort-${item.sort_icon}-down` " 
                                        size="lg" @click="sortColumn(item.sortingKey, 'asc')">
                                    </i>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                v-for="(offer, key) in filterOffersList" :key="key"
                                :class="{'pt-1 pb-3' : $breakpoint.smAndDown}"
                            >
                                <td label="Seller" v-if="offer.seller_details"><span>{{offer.seller_details.name}}</span></td>
                                <td v-else><span>N/A</span></td>
                                <td label="Terminal" v-if="serviceSelected !== 'Bunkering'"><span>{{offer.terminal_id| terminalsname }}</span></td>
                                <td label="Vol Min-Max/L">
                                    <span v-if="offer.contract && offer.contract.frequency_quantity && offer.contract.frequency_quantity.length > 0">{{offer.minimumOrderQuantity | volumeformat}} - {{offer.contract.frequency_quantity | currentMonthMaximumAvailable}}</span>
                                    <span v-else>{{offer.minimumOrderQuantity | volumeformat}} - {{offer.maximumAvailable | volumeformat}}</span>
                                </td>
                                <td label="Vol Total/L" v-if="serviceSelected == 'Contracts'"><span>{{offer.contract.totalQuantity | volumeformat}}</span></td>
                                <td label="Measurement"><span>{{offer.fuel_measurement_id | fuelmeasurementtype}}</span></td>
                                <td label="Lifting Period" v-if="serviceSelected == 'Ex-Rack' || serviceSelected == 'Contracts'">
                                    <span v-if="offer.storage_type_id == 'SPOT'">{{offer | liftingperiodformat}}</span>
                                    <span v-else>N/A</span>
                                </td>
                                <td label="Payment Terms" v-if="offer.credit"><span>{{ offer.credit.days | creditdaysformat }}</span></td>
                                <td v-else><span>N/A</span></td>
                                <td label="Offer Type" v-if="serviceSelected !== 'Contracts'"><span>{{offer.isContract | contracttype}}</span></td>
                                <td label="Price (ppl)">
                                    <span>{{offer.price | priceformat}}&nbsp;</span>
                                    <i 
                                        v-if="offer.type_id === 'TRACKING'"
                                        class="fas fa-sm fa-rss tracking-active-icon-color mb-2"
                                        data-toggle="tooltip" data-placement="bottom" 
                                        title="This Offer Price updates every 30 seconds"
                                    ></i>
                                </td>
                                <td class="text-right td-actions">
                                    <button :class="{contracts:isContract}" class="btn btn-confirm w-120px" :disabled=getIsPlatformClosed @click="openBasket(offer, $event)">Buy</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import breakpoint from '@/mixins/index';
import OfferBasket from '@/modals/OfferBasket.vue'
import OrderIdReceipt from "@/modals/OrderIdReceipt.vue";
import CreateBasketMixin from '@/mixins/CreateBasketMixin'
import { organiseOrders } from '../util/orderBuilder'
import { getCurrentMonthDataFromContract } from '../util/util.js'
import { hasContractRemainingQuantity } from '@/util/contracts.js';
import { getOtherAvailableHaulages } from '@/util/haulages.js';

export default {
    mixins: [breakpoint, CreateBasketMixin],
        components:{
        OfferBasket,
        OrderIdReceipt
    },
    data(){
        return{
            showBasket: false,
            showOrderIdReceipt: false,
            basketOrder: {},
            offersList: [],
            filteredOffersList: [],
            filtersSelected: {
                'EX-RACK':'',
                'BUNKERING':'',
                'DELIVERED IN':'',
                'CONTRACTS':''
            },
            deliveredInDaysSelected: [],
            fuelsTypeMenu:[],
            activeSortColumn: '',
            activeSortDirection: '',
            showNoOfferMessage:false,
            isSorting:false,
            columnTitle:[
                {title:'Delivery Location',used_by:['Delivered in'],
                sort_icon:'alpha', sortingKey: 'delivery_location'},

                {title:'Seller',used_by:['Bunkering','Ex-Rack','Delivered in','Contracts'],
                sort_icon:'alpha', sortingKey: 'seller'},

                {title:'Terminal',used_by:['Ex-Rack','Contracts'],
                sort_icon:'alpha', sortingKey: 'terminal'},
                
                {title:'Vol Max/L',used_by:['Delivered in'],
                sort_icon:'numeric', sortingKey: 'volume_max'},
                
                {title:'Vol Min-Max/L',used_by:['Bunkering','Ex-Rack', 'Contracts'],
                sort_icon:'numeric', sortingKey: 'volume_max'},

                {title:'Total Vol/L',used_by:['Contracts'],
                sort_icon:'numeric', sortingKey: 'volume_total'},

                {title:'Measurement',used_by:['Bunkering','Ex-Rack','Delivered in','Contracts'],
                sort_icon:'alpha', sortingKey: 'measurement'},

                {title:'Delivery Date',used_by:['Delivered in'],
                sort_icon:'alpha', sortingKey: 'delivery_date'},

                {title:'Lifting Period',used_by:['Ex-Rack','Contracts'],
                sort_icon:'numeric', sortingKey: 'collection_days'},

                {title:'Payment Terms',used_by:['Bunkering','Ex-Rack','Delivered in','Contracts'],
                sort_icon:'numeric', sortingKey: 'credit_days'},

                {title:'Offer Type',used_by:['Bunkering','Ex-Rack','Delivered in'],
                sort_icon:'alpha', sortingKey: 'offer_type'},

                {title:'Price (ppl)',used_by:['Bunkering','Ex-Rack','Delivered in','Contracts'],
                sort_icon:'numeric', sortingKey: 'price'},
            ],
            isContract:false,
            serviceSelected:'',
            favorites:[],
            isDataPopulated: false
        }
    },

    created: function (){
        this.selectFavourites
        if (this.suppliers.length === 0) {
            this.getRelationships()
        }
        let service
        this.marketFavouritesList.forEach(x=>{
            this.favorites.push(x.type)
        })
        if (this.$router.history.current.params.tab==="ex-rack" && this.favorites.indexOf("Ex-Rack") > -1 ){
            service = "Ex-Rack"
        }else if (this.$router.history.current.params.tab==="contract" && this.favorites.indexOf("Contracts")> -1 ){
            service = "Contracts"
        }else if (this.$router.history.current.params.tab==="deliveredIn" && this.favorites.indexOf("Delivered in")> -1 ){
            service = "Delivered in"
        }else if (this.$router.history.current.params.tab==="bunkering" && this.favorites.indexOf("Bunkering")> -1 ){
            service = "Bunkering"
        }else{
            service=null
        }
        let key = this.favorites.indexOf(service)
        if (service){
            this.selectFavouriteOption({key, service})
        }
        this.isDataPopulated = true;
    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
    computed:{
        ...mapGetters('buyerOpen', ['getIsPlatformClosed']),
        ...mapState('offers',['liveOffers', 'haulageAvailableList', 'displayFilteredOffers', 'deliveryLocations']),
        ...mapState('accounts', ['suppliers']),
        ...mapState('selectFavourites',['marketFavouritesList','favCreated',
        'favouriteOptionSelected','selectFavouritesModal','serviceSelectedName','listOfServicesCreated',
        'showConfirmationRemoveFavourite']),
        ...mapGetters('fuelsType',['getFuelsType']),
        ...mapGetters('metadata', ['productConfig', 'networkConfig', 'networks']),
        favouriteOptions: {
            get: function(){
                return this.marketFavouritesList
            }
        },
        fuelTypeListExrack: {
            get: function() {
                let fuelsList = []
                
                if (this.getFuelsType){
                    this.getFuelsType.forEach((fuel, index) => {
                        if (fuel.type == 'SPOT')
                            fuelsList.splice(index + 1, 1, fuel)
                    })
                }
                return fuelsList
            }
        },
        fuelTypeListBunkering: {
            get: function() {
                let fuelsList = []
                
                if (this.getFuelsType){
                    this.getFuelsType.forEach((fuel, index) => {
                        if (fuel.type == 'BUNKERING')
                            fuelsList.splice(index + 1, 1, fuel)
                    })
                }
                return fuelsList
            }
        },
        daysList: {
            get: function(){
                const moment = require('moment');
                const momentBusiness = require('moment-business-days');

                const today = moment().format('DD-MM-YYYY');
                let days = []

                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(1)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(2)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(3)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(4)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(5)._d)

                return days
            }
        },
        haulageList: {
            get: function(){
                const moment = require('moment');

                if (this.filtersSelected['DELIVERED IN'] && this.haulageAvailableList){
                    let list = []
                    let daysSelected = []

                    /* Re-format days selected here to safeguard against changes */
                    if (this.deliveredInDaysSelected){
                        this.deliveredInDaysSelected.forEach((day, index) => {
                            daysSelected.push(moment(day).format('DD-MM-YYYY'))
                        })
                    }

                    /* Filter based on fuel type */
                    list = this.haulageAvailableList.filter(haulage => {
                        if (this.filtersSelected['DELIVERED IN']._id == this.productConfig.DieselId){
                            return (haulage.fuel.id == this.productConfig.DieselId || haulage.fuel.id == this.productConfig.BlendedDieselBioId)
                        }
                        else if (this.filtersSelected['DELIVERED IN']._id == this.productConfig.GasoilId){
                            return haulage.fuel.id == this.productConfig.GasoilId || haulage.fuel.id == this.productConfig.BlendedGasoilId
                        }
                        else {
                            return haulage.fuel.id == this.filtersSelected['DELIVERED IN']._id
                        }
                    })
                    // Filter based on days selected
                    list = list.filter(haulage => daysSelected.includes(moment(haulage.deliveryDate).format('DD-MM-YYYY')))

                    /* Attach the relevant offer and seller details */
                    list.forEach(haulage => {
                        haulage.valid = true
                        haulage.seller_details = this.suppliers.find(supplier => supplier.id == haulage.account_id)
                    })
                    let offerLocationsIDs = [... new Set(list.map(a => a.location_id))]; 
                    this.locationsWithoutOffers = this.deliveryLocations.filter(location => {
                        if(!offerLocationsIDs.includes(location._id)){
                            return location
                        }
                    })
                    this.locationsWithoutOffers.forEach(function(element) {
                        list.push(element)
                    });

                    /* If any column has been selected for sorting, then re-apply sorting */
                    if (this.activeSortColumn && this.activeSortDirection){
                        return this.sortColumn(this.activeSortColumn, this.activeSortDirection, list)
                    }

                    return list
                }
            }
        },
        canTriggerModalNow(){
            if(this.selectFavouritesModal){
                let element = this.$root.$refs.selectFavourites.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
            return this.selectFavouritesModal
        },
        
        dropDownOptions() {
          if(this.serviceSelected && this.marketFavouritesList.length > 0) {
            if (this.serviceSelected == 'Delivered in') {
              this.deliveredInDaysSelected = Object.assign([], this.daysList);
              return this.favouriteOptions[this.favouriteOptionSelected].fuels;
            } else if (this.serviceSelected === 'Bunkering') {
              return (this.favouriteOptions.find(item => item.type === 'Bunkering').networks || [])
            } else if (this.serviceSelected === 'Contracts') {
              return [...this.favouriteOptions[this.favouriteOptionSelected].fuels, ...this.networks];
            }
            else {
              /* Load all fuels selected for selected service type */
              return this.favouriteOptions[this.favouriteOptionSelected].fuels;
            }
          } else {
            return [];
          }
        },

        selectVmodelFuelDropDown:{
            get(){
                /* If there is a fuel type previously selected on this tab, return this fuel type,
                 * otherwise pre-select the first fuel type available in the dropdown */
                if (this.filtersSelected[this.serviceSelected.toUpperCase()]){
                    return this.filtersSelected[this.serviceSelected.toUpperCase()]
                }
                else {
                    this.filtersSelected[this.serviceSelected.toUpperCase()] = this.dropDownOptions[0]
                    return this.dropDownOptions[0]
                }
            },
            set(newVal,name){
                this.filtersSelected[this.serviceSelected.toUpperCase()] = newVal;
            }
            
        },

        filterOffersList(){
            let offers = [];
            const service = this.serviceSelected.toUpperCase();

            if (this.filtersSelected[service]){
                const fuelToCheck = this.filtersSelected[service] && this.filtersSelected[service]._id;
    
                if(fuelToCheck){
                    offers = this.offersList.filter(offer => {
                        /* If this is Contracts tab, return Bunkering offers under Diesel */
                        if (service === 'CONTRACTS' && (fuelToCheck == this.networkConfig.KeyFuelsId || fuelToCheck == this.networkConfig.UkFuelsId)) {
                            if (fuelToCheck == this.networkConfig.KeyFuelsId){
                                return offer.networkId == this.networkConfig.KeyFuelsId;
                            }
                            else if (fuelToCheck == this.networkConfig.UkFuelsId){
                                return offer.networkId == this.networkConfig.UkFuelsId;
                            }
                            else {
                                return false
                            }
                        }
                        /* If this is Bunkering tab, filter based on network id */
                        else if (service === 'BUNKERING') {
                          return fuelToCheck === offer.networkId;
                        }
                        else {
                            if (fuelToCheck == this.productConfig.DieselId && offer.storage_type_id == 'SPOT'){
                                return offer.fuel_id == this.productConfig.DieselId || offer.fuel_id == this.productConfig.BlendedDieselBioId
                                    && offer.storage_type_id == 'SPOT'
                            }
                            else if (fuelToCheck == this.productConfig.GasoilId){
                                return offer.fuel_id == this.productConfig.GasoilId || offer.fuel_id == this.productConfig.BlendedGasoilId
                            }
                            else if (offer.storage_type_id == 'SPOT'){
                                return offer.fuel_id == fuelToCheck
                            }
                        }
                    })
                }
    
                /* If any column has been selected for sorting, then re-apply sorting */
                if (this.activeSortColumn && this.activeSortDirection){
                    return this.sortColumn(this.activeSortColumn, this.activeSortDirection, offers)
                }
    
                offers = offers.filter(o => !o.isContract || (o.isContract && hasContractRemainingQuantity(o.contract.frequency_quantity, o.minimumOrderQuantity)));
            }

            return offers;
        },
        getOffers: function (){
            //if liveOffers doesn't contain any data return 
            if (this.marketFavouritesList.length < 1){
                return
            }
            if (this.isDataPopulated){
                const serviceOptionSelected = this.marketFavouritesList[this.favouriteOptionSelected].type
         
                if(this.isSorting){
                    //if the function has been trigger because of the sorting we don't want to go further
                    this.isSorting=false;
                    return
                }
                this.showNoOfferMessage = false;
                let isBunkering = false
                let isDeliveredIn=false
                let isContract= false
                this.serviceSelected=serviceOptionSelected;
                
                //SELECTING EX-RACK AND BUNKERING FOR SPOT OPTION 
                let offers= this.liveOffers.filter(offer => {
                    /* If tab selected is "Contracts" then return just contract offers,
                    * otherwise filter according to storage type */
                    if (serviceOptionSelected === 'Contracts'){
                        isContract = true
                        return this.checkForVolumeRemaining(offer);
                    } else {
                        if (serviceOptionSelected === 'Ex-Rack'){
                            return offer.storage_type_id === 'SPOT' && !offer.offerHidden
                        }
                        else if (serviceOptionSelected === 'Bunkering'){
                            isBunkering = true
                            return offer.storage_type_id === 'BUNKERING' && !offer.offerHidden
                        }
                        else {
                            isDeliveredIn = true
                        }
                    }
                })
                
                let filteredOffersList;
                if(!isBunkering && !isContract){
                    if(!isDeliveredIn){
                        const arrayOfTerminals_id=[]
                        this.marketFavouritesList[this.favouriteOptionSelected].terminals.forEach(terminal=>{
                                arrayOfTerminals_id.includes(terminal._id) ? ''
                                : arrayOfTerminals_id.push(terminal._id)            
                        })      
                        //filtering by terminals id
                        filteredOffersList = offers.filter(offer=>{
                            if(arrayOfTerminals_id.includes(offer.terminal_id)){
                                return offer
                            }
                        })
                    }
                    if(!filteredOffersList){
                        filteredOffersList=[...offers]
                    }
                    //filter fuels
                    filteredOffersList.filter(offer=>{
                        return this.marketFavouritesList[this.favouriteOptionSelected].fuels.includes(offer.fuel_id)
                    })
                    //on fuels dropdwon each type must appear just once 
                    filteredOffersList.forEach(offer=>{
                        if(!this.fuelsTypeMenu.includes(offer.fuel._id) ) {
                            this.fuelsTypeMenu.push(offer.fuel._id)
                        }
                    })
                    
                }
                //find sellers and terminal 
                let finalList
                if(isBunkering || isContract){
                    finalList=[...offers]
                }else{
                    finalList=[...filteredOffersList]  
                }
                
                finalList.forEach(offer => {
                    offer.seller_details = this.suppliers.find(supplier => supplier.id == offer.account_id)
                })   
                
                this.offersList=finalList
            
                this.updateFavouriteWithId(this.offersList)
                this.activeSortDirection = ''
                if(this.offersList.length < 1 || this.filterOffersList.length < 1){
                    this.showNoOfferMessage=true;
                    return;
                }
                return this.offersList
            }
        },
        triggerRemoveFavouriteModal: function() {
            if (this.showConfirmationRemoveFavourite){
                let element = this.$root.$refs.confirmationRemoveFavourite.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        },
        isGreenBsp() {
            return process.env.VUE_APP_Platform === "Greenergy";
        }
    },
    watch:{
        getOffers(){},
        canTriggerModalNow(){},
        triggerAddLocationModal(){},
        triggerEditLocationModal(){},
        triggerRemoveFavouriteModal(){}
    },
    methods:{
        ...mapActions('accounts',['getRelationships']),
        ...mapActions('orders',['createBasket']),
        ...mapActions("selectFavourites",["openModal","selectFavouriteOption","updateFavouriteList",
            'updateShowConfirmationRemoveFavourite']),
        checkForVolumeRemaining(offer){
            let currentMonth;
            if(offer.contract && offer.contract.frequency_quantity){
                currentMonth = getCurrentMonthDataFromContract(offer.contract.frequency_quantity);
            }
            return offer.isContract && !offer.offerHidden && (currentMonth ? currentMonth.maximumAvailable > 0 : true);
        },
        selectDay: function(daySelected){
            if (this.deliveredInDaysSelected.includes(daySelected)){
                const dayMatchIndex = this.deliveredInDaysSelected.findIndex(day => day == daySelected)
                this.deliveredInDaysSelected.splice(dayMatchIndex, 1)
            }
            else {
                this.deliveredInDaysSelected.push(daySelected)
            }
        },
        checkServiceSelected(){
            const typeToReturn = this.serviceSelectedName ==='Bunkering' ? 'BUNKERING' : 'SPOT'
            return typeToReturn
        },
        hideBasket(){
            this.showBasket = false;
        },
        triggerReceiptModal(order){
            this.basketOrder = organiseOrders([order], this.$store.getters['login/getAccountType'], this.$store.getters['metadata/networks'])
            this.showOrderIdReceipt = true
        },
        hideReceiptModal() {
            this.showOrderIdReceipt = false
        },
        updateFavouriteWithId(list){
            this.updateFavouriteList(list)
        },
        openModalMethod(){
            //if 4 options alreadyt been created return 
            if(this.listOfServicesCreated.length>=4){
                return
            }
            this.openModal()
        },
        selectTab(key,serviceName){
            event.preventDefault()
            if(serviceName==="Delivered in"){
                this.$router.push('/buyerDashboard/deliveredIn')
            }else if(serviceName==="Contracts"){
                    this.$router.push('/buyerDashboard/contracts')
            }else if(serviceName==="Ex-Rack"){
                this.$router.push('/buyerDashboard/ex-rack')
            }else if(serviceName==="Bunkering"){
                this.$router.push('/buyerDashboard/bunkering')
            }else{
                console.log(serviceName)
            }
            this.selectFavouriteOption({key,serviceName})
        },
        removeFavourite: function() {
            this.updateShowConfirmationRemoveFavourite(true)
        },
        sortColumn: function(sortingKey, direction, list){
            let listToSort = list ? list : (this.serviceSelected == 'Delivered in' ? this.haulageList : this.filterOffersList)
            this.isSorting = true;
            let stringA = ''
            let stringB = ''
            this.activeSortDirection = direction
            this.activeSortColumn = sortingKey

            const sortManyWays = (dataToSort, sortBy, sortOrder) => {
                const parentObject = this.serviceSelected == 'Delivered in' && dataToSort[0].offer ? dataToSort[0].offer : dataToSort[0]
                const typeOfDetail = typeof(parentObject[sortBy]) === 'number' ? 'isNumber' : 'isString'

                dataToSort.sort((a,b) => {
                    const objectA = this.serviceSelected == 'Delivered in' && a.offer ? a.offer : a
                    const objectB = this.serviceSelected == 'Delivered in' && b.offer ? b.offer : b
                    
                    if(typeOfDetail==='isNumber'){
                        if(sortOrder==='asc'){
                            return objectA[`${sortBy}`] - objectB[`${sortBy}`]
                        }
                        return objectB[`${sortBy}`] - objectA[`${sortBy}`]
                    }
                    else{
                        if (parentObject[sortBy] == undefined){
                            return
                        }
                        else {
                            const stringA = objectA[`${sortBy}`] !== undefined ? objectA[`${sortBy}`] : 'zzz'
                            const stringB = objectB[`${sortBy}`] !== undefined ? objectB[`${sortBy}`] : 'zzz'
                            
                            if(sortOrder==='asc'){
                                return stringA.localeCompare(stringB)
                            }
                            else{  
                                return stringB.localeCompare(stringA)
                            }        
                        }
                    }
                        
                })

                return dataToSort
            }
           
            switch (sortingKey){
                case 'delivery_location': // Sort by delivery location
                    return listToSort.sort((a, b) => {
                        stringA = a.location ? a.location.name : a.name
                        stringB = b.location ? b.location.name : b.name

                        if (direction == 'asc'){
                            return stringA.localeCompare(stringB, 'en')
                        }
                        else {
                            return stringB.localeCompare(stringA, 'en')
                        }
                    })
                case 'terminal': // Sort by terminal
                    return listToSort.sort((a, b) => {
                        if (a.terminal && b.terminal){
                            stringA = a.terminal.name
                            stringB = b.terminal.name
                        }
                        else if (a.terminal){
                            stringA = a.terminal.name
                            stringB = 'N/A'
                        }
                        else if (b.terminal) {
                            stringA = 'N/A'
                            stringB = b.terminal.name
                        }
                        else {
                            stringA = 'N/A'
                            stringB = 'N/A'
                        }

                        if (direction == 'asc'){
                            return stringA.localeCompare(stringB, 'en')
                        }
                        else {
                            return stringB.localeCompare(stringA, 'en')
                        }
                    })
                case 'seller': // Sort by seller
                    return listToSort.sort((a, b) => {
                        stringA = a.seller_details ? a.seller_details.name : 'zzz'
                        stringB = b.seller_details ? b.seller_details.name : 'zzz'

                        if (direction == 'asc'){
                            return stringA.localeCompare(stringB)
                        }
                        else {
                            return stringB.localeCompare(stringA)
                        }
                    })
                case 'volume_min': // Sort by minimum volume
                    return sortManyWays(listToSort, 'minimumOrderQuantity', this.activeSortDirection)
                case 'volume_max': // Sort by maximum volume
                    return sortManyWays(listToSort, 'maximumAvailable', this.activeSortDirection)
                case 'volume_total': // Sort by total volume
                    return listToSort.sort((a, b) => {
                        stringA = a.maximumAvailable - a.contract.orderedQuantity
                        stringB = b.maximumAvailable - b.contract.orderedQuantity
                        if (direction == 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })    
                case 'measurement': // Sort by fuel measurement type
                    return sortManyWays(listToSort, 'fuel_measurement_id', this.activeSortDirection)
                case 'collection_days': // Sort by Lifting Period
                    return sortManyWays(listToSort, 'collectionTime', this.activeSortDirection)      
                case 'delivery_date': // Sort by delivery date
                    return listToSort.sort((a, b) => {
                        stringA = a.deliveryDate ? new Date(a.deliveryDate) : Number.MAX_SAFE_INTEGER
                        stringB = b.deliveryDate ? new Date(b.deliveryDate) : Number.MAX_SAFE_INTEGER

                        if (direction == 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })      
                case 'credit_days': // Sort by credit days
                    return listToSort.sort((a, b) => {
                        if (this.serviceSelected == 'Delivered in'){
                            stringA = a.offer && a.offer.credit ? a.offer.credit.days : Number.MAX_SAFE_INTEGER;
                            stringB = b.offer && b.offer.credit ? b.offer.credit.days : Number.MAX_SAFE_INTEGER;
                        } else {
                            stringA = a.credit ? a.credit.days : Number.MAX_SAFE_INTEGER;
                            stringB = b.credit ? b.credit.days : Number.MAX_SAFE_INTEGER;
                        }

                        if (direction == 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })    
                case 'offer_type': // Sort by offer type
                    return listToSort.sort((a, b) => {
                        const objectA = this.serviceSelected == 'Delivered in' && a.offer ? a.offer : a
                        const objectB = this.serviceSelected == 'Delivered in' && b.offer ? b.offer : b

                        stringA = this.$root.$options.filters.contracttype(objectA.isContract)
                        stringB = this.$root.$options.filters.contracttype(objectB.isContract) 

                        if (direction == 'asc'){
                            return stringA.localeCompare(stringB)
                        }
                        else {
                            return stringB.localeCompare(stringA)
                        }
                    })
                case 'price': // Sort by price
                    return sortManyWays(listToSort, 'price', this.activeSortDirection)
                default:
                    return listToSort
            }
        }
    }
}
</script>